import { MEDIA_LIMITS_MB } from './constants';

export function kindOfFile(file) {
  if (file.type.startsWith('image/')) return 'image';
  if (file.type.startsWith('video/')) return 'video';
  return 'file';
}

export function validateAttachment(file) {
  if (!file?.size) return 'Пустой файл';

  const kind = kindOfFile(file);
  const limitMb = MEDIA_LIMITS_MB[kind];
  const limitBytes = limitMb * 1024 * 1024;

  if (file.size > limitBytes) {
    return `Файл больше ${limitMb} МБ`;
  }

  return null;
}

export function formatFileSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
}

export function getSupportChatErrorMessage(error) {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;

  switch (status) {
    case 413:
      return 'Файл слишком большой';
    case 429:
      return 'Слишком часто, попробуйте через минуту';
    case 400:
      return 'Пустой файл';
    case 503:
      return 'Сервис временно недоступен';
    case 401:
      return 'Чат временно недоступен';
    case 422:
      return detail || 'Ошибка отправки';
    default:
      return detail || error?.message || 'Ошибка отправки';
  }
}
